var components = {'uIcon': require('@/uni_modules/uview-ui/components/u-icon/u-icon.vue').default}
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"u-search",style:([{
		margin: _vm.margin,
	}, _vm.$u.addStyle(_vm.customStyle)]),on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clickHandler).apply(void 0, arguments)
}}},[_c('v-uni-view',{staticClass:"u-search__content",style:({
			backgroundColor: _vm.bgColor,
			borderRadius: _vm.shape == 'round' ? '100px' : '4px',
			borderColor: _vm.borderColor,
		})},[(_vm.$slots.label || _vm.label !== null)?[_vm._t("label",[_c('v-uni-text',{staticClass:"u-search__content__label"},[_vm._v(_vm._s(_vm.label))])])]:_vm._e(),_c('v-uni-view',{staticClass:"u-search__content__icon"},[_c('u-icon',{attrs:{"size":_vm.searchIconSize,"name":_vm.searchIcon,"color":_vm.searchIconColor ? _vm.searchIconColor : _vm.color},on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clickIcon).apply(void 0, arguments)
}}})],1),_c('v-uni-input',{staticClass:"u-search__content__input",style:([{
				textAlign: _vm.inputAlign,
				color: _vm.color,
				backgroundColor: _vm.bgColor,
				height: _vm.$u.addUnit(_vm.height)
			}, _vm.inputStyle]),attrs:{"confirm-type":"search","value":_vm.value,"disabled":_vm.disabled,"focus":_vm.focus,"maxlength":_vm.maxlength,"placeholder-class":"u-search__content__input--placeholder","placeholder":_vm.placeholder,"placeholder-style":("color: " + _vm.placeholderColor),"type":"text"},on:{"blur":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.blur).apply(void 0, arguments)
},"confirm":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.search).apply(void 0, arguments)
},"input":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.inputChange).apply(void 0, arguments)
},"focus":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.getFocus).apply(void 0, arguments)
}}}),(_vm.keyword && _vm.clearabled && _vm.focused)?_c('v-uni-view',{staticClass:"u-search__content__icon u-search__content__close",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clear).apply(void 0, arguments)
}}},[_c('u-icon',{attrs:{"name":"close","size":"11","color":"#ffffff","customStyle":"line-height: 12px"}})],1):_vm._e()],2),_c('v-uni-text',{staticClass:"u-search__action",class:[(_vm.showActionBtn || _vm.show) && 'u-search__action--active'],style:([_vm.actionStyle]),on:{"click":function($event){$event.stopPropagation();$event.preventDefault();
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.custom).apply(void 0, arguments)
}}},[_vm._v(_vm._s(_vm.actionText))])],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }